import React from 'react';
import { cn } from '@/lib/utils';

export const Logo = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("h-full w-full", className)}
        {...props}
    >
        <circle cx="12" cy="12" r="11" fill="hsl(var(--muted))" />
        <g 
            transform="translate(3.6, 3.6) scale(0.7)"
            stroke="hsl(var(--primary))" 
            strokeWidth="1.8" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            fill="none"
        >
          {/* Fork */}
          <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
          <path d="M7 2v20" />
          {/* Knife */}
          <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3z" />
          <path d="M21 15v7" />
        </g>
    </svg>
);
